import React from 'react';
import { FieldArray, connect as formikConnect } from 'formik';

import extend from 'extend';

// import FormField from '../FormField';
import FieldGroup from '../FieldGroup';

export default 
@formikConnect
class DynamicFieldArray extends React.Component {

	renderSubFields(subFields, index) {

		const { name, isEditing } = this.props;

		// inject index into keys
		subFields = subFields.map((subField, i) => {
			subField = extend(true, {}, subField);
			subField.name =  `${name}.${index}.${subField.name}`
			return <FieldGroup key={i} {...subField} isEditing={isEditing} />
		});

		return subFields;
		
	}

	render() {
		const { name, formik, subFields } = this.props;
		const values = formik.values[name];

		return (
			<FieldArray 
				name={name} 
				render={arrayHelpers => (
					<div>
						{
							values.map((v, i) => (
								<div key={i}>
									<h4>Previous Position {i+1}</h4>
									{this.renderSubFields(subFields, i)}
								</div>
							))
						}
					</div>
				)}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/FieldArray.jsx